import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { connect } from "react-redux";
import Row from "../../components/Row";
import Col from "../../components/Col";
import Heading from "../../components/Heading";
import Input from "../../components/Input";
import Textarea from "../../components/Textarea";
import Form from "../../components/Form";
import { Multiselect } from "multiselect-react-dropdown";
import { Carousel } from "react-responsive-carousel";
import * as client from "../../services/client";
import Loader from "../../components/Loader";
import Checkbox from "../../components/Checkbox";
// import { Editor } from "react-draft-wysiwyg";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import { EditorState, convertToRaw, convertFromRaw,ContentState,convertFromHTML } from 'draft-js';
import TextEditor from "../../components/Editor/Editor";
import { DownloadableAssetCard } from "../../components/DownloadableAssetCard/DownloadableAssetCard";

class Announcementsview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      loader: false,
      editorState: props.data.description ? props.data.description : "",
      hideToolbar: true,
    };
  }
  componentDidMount() {
    this.setState({
      loader: true,
    });
    client.getAnnouncementById(this.props.data.id).then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responseJson) => {
          this.setState({ formData: responseJson.data, loader: false });
        });
      }
    });
  }
  render() {
    const { onClose, user } = this.props;
    let announcementFormData = this.state.formData;
    let homeOwnerCheck =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].role.name === "Home Owner" ||
        user.roles[0].role.name === "Occupant")
        ? true
        : false;

    let attachments =
      announcementFormData && announcementFormData.attachments
        ? JSON.parse(announcementFormData.attachments)
        : [];
    const sortedAttachments = {
      images: [],
      downloads: [],
    };
    attachments.forEach((attachment) => {
      if (attachment.url.match(/(.jpg)|(.jpeg)|(.png)/gi))
        sortedAttachments.images.push(attachment);
      else sortedAttachments.downloads.push(attachment);
    });
    let buildings = announcementFormData.buildings
      ? announcementFormData.buildings.length > 0
        ? announcementFormData.buildings.map((item) => {
            return {
              id: item.buildingLevelId,
              name: item.name,
            };
          })
        : []
      : [];
    let levels = announcementFormData.levels
      ? announcementFormData.levels.length > 0
        ? announcementFormData.levels.map((item) => {
            return {
              id: item.buildingLevelId,
              name: item.name,
            };
          })
        : []
      : [];

    let units = announcementFormData.announcementSuites
      ? announcementFormData.announcementSuites.length > 0
        ? announcementFormData.announcementSuites.map((item) => {
            return {
              id: item.unitId,
              name: item.name,
            };
          })
        : []
      : [];
    return (
      <>
        {this.state.loader ? (
          <Loader center={true} />
        ) : (
          <Form
            headline={"Announcement View"}
            onClose={onClose}
            component={
              <>
                <Heading>Announcement Details</Heading>
                {homeOwnerCheck ? (
                  <>
                    <Row mdCenter>
                      <Col xs="12" md="6">
                        <Input
                          value={announcementFormData.propertyName}
                          label="Property Name"
                          disabled={true}
                          block
                        />
                        <Input
                          value={announcementFormData.title}
                          label="Title"
                          disabled={true}
                          block
                        />

                        <div className="input">
                          <div className="input__require">
                            <label className="input__label">Description</label>
                            {/* <div className="input__required" /> */}
                          </div>

                          <div
                            class="md"
                            style={{
                              borderBottom:
                                "0.1rem solid rgba(83, 83, 83, 0.25)",
                            }}
                            className="input__control"
                          >
                            {/* {<div style={{textAlign:"left"}} dangerouslySetInnerHTML={{__html: announcementFormData.description}} />} */}
                            <TextEditor
                              editorState={announcementFormData.description}
                              readOnly={true}
                              toolbarHidden={true}
                            />
                          </div>
                        </div>

                        {attachments && attachments.length > 0 ? (
                          <div
                            className="textarea__label"
                            style={{ display: "flex", marginBottom: 10 }}
                          >
                            Attachments Testing
                          </div>
                        ) : null}

                        <Carousel autoPlay>
                          {sortedAttachments.images.length > 0
                            ? sortedAttachments.images.map((data, i) => {
                                return (
                                  <div style={{ backgroundColor: "#fff" }}>
                                    <img alt="" src={data.url} />
                                  </div>
                                );
                              })
                            : null}
                        </Carousel>
                        {sortedAttachments.downloads.map((data) => {
                          return (
                            <DownloadableAssetCard
                              title={data.title}
                              url={data.url}
                            />
                          );
                        })}
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row>
                      <Col xs="12" md="6">
                        <Input
                          value={announcementFormData.propertyName}
                          label="Property Name"
                          disabled={true}
                          block
                        />
                        <Row>
                          <Col xs="12" md="3">
                            <label
                              for="Building"
                              style={{ padding: "0px 20px 0px 5px" }}
                            >
                              <Checkbox
                                id="Buildings"
                                name="plan"
                                value={announcementFormData.isBuilding}
                                disabled={true}
                                block
                                checked={announcementFormData.isBuilding}
                              />
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Buildings
                            </label>
                          </Col>
                          <Col xs="12" md="6">
                            <label
                              for="Floor"
                              style={{ padding: "0px 20px 0px 5px" }}
                            >
                              <Checkbox
                                id="Floor/Level"
                                name="plan"
                                value={announcementFormData.isLevel}
                                disabled={true}
                                block
                                checked={announcementFormData.isLevel}
                              />
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Floor/Level
                            </label>
                          </Col>
                        </Row>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "10px",
                            }}
                          >
                            <div
                              className="reporting__heading"
                              style={{ color: "black" }}
                            >
                              {announcementFormData.isBuilding
                                ? "Buildings"
                                : "Floor/Level"}
                            </div>
                          </div>

                          <Multiselect
                            id="building"
                            displayValue="key"
                            selectedValues={
                              announcementFormData.isBuilding
                                ? buildings
                                : levels
                            }
                            displayValue="name"
                            disable={true}
                          />
                        </div>
                        <br />
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            className="reporting__heading"
                            style={{ color: "black" }}
                          >
                            Unit(s)
                          </div>
                        </div>
                        <Multiselect
                          displayValue="key"
                          selectedValues={units}
                          displayValue="name"
                          disable={true}
                        />
                        <br />
                      </Col>
                      <Col xs="12" md="6">
                        <Input
                          value={announcementFormData.title}
                          label="Title"
                          disabled={true}
                          block
                        />
                        {/* <Textarea
                value={announcementFormData.description}
                label="Description"
                disabled={true}
                block
              /> */}
                        <div className="input">
                          <div className="input__require">
                            <label className="input__label">Description</label>
                          </div>

                          <div
                            class
                            style={{
                              borderBottom:
                                "0.1rem solid rgba(83, 83, 83, 0.25)",
                              marginTop: "-7px",
                            }}
                            className="input__control"
                          >
                            <TextEditor
                              editorState={announcementFormData.description}
                              readOnly={true}
                              toolbarHidden={true}
                            />
                          </div>
                        </div>

                        {attachments && attachments.length > 0 ? (
                          <div
                            className="textarea__label"
                            style={{ display: "flex", marginBottom: 10 }}
                          >
                            Attachments
                          </div>
                        ) : null}

                        <Carousel autoPlay>
                          {sortedAttachments.images.length > 0
                            ? sortedAttachments.images.map((data, i) => {
                                return (
                                  <div style={{ backgroundColor: "#fff" }}>
                                    <img alt="" src={data.url} />
                                  </div>
                                );
                              })
                            : null}
                        </Carousel>
                        {sortedAttachments.downloads.map((data) => {
                          return (
                            <DownloadableAssetCard
                              title={data.title}
                              url={data.url}
                            />
                          );
                        })}
                      </Col>
                    </Row>
                  </>
                )}
              </>
            }
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  // loader: selectPRLoader(state)
  user: selectAuthenticatedUser(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Announcementsview);
